import React from "react";
import { Element } from "@craftjs/core";
import { Container } from "../../components/user/Container";
import { Text } from "../../components/user/Text";
import { Button } from "../../components/user/Button";

export const CTASection = () => {
  return (
    <Element
      id="cta_section_container"
      canvas
      is={Container}
      className="cta-section"
      padding="60px 20px"
      background="#1a1a2e"
      margin="0"
      borderRadius={0}
      width="100%"
      height="auto"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
    >
      <Text
        text="Ready to Start Gaming?"
        fontSize={36}
        color="#ffffff"
        fontWeight="bold"
        textAlign="center"
        margin="0 0 20px 0"
        padding="0"
      />
      <Text
        text="Enter your mobile number now to access thousands of games"
        fontSize={18}
        color="#e5e7eb"
        fontWeight="normal"
        textAlign="center"
        margin="0 0 30px 0"
        padding="0"
      />
      <Button
        text="GET STARTED NOW"
        fontSize={20}
        color="#ffffff"
        backgroundColor="#3b82f6"
        borderRadius={8}
        padding="15px 30px"
      />
    </Element>
  );
};
